import {Box, Typography} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import React from "react";
import useStyles from "./styles";

type TopBarProps = {
  showLogoUrl?: string;
  title?: string;
  organiserLogoUrl?: string;
};

const TopBar: React.FC<TopBarProps> = ({
  title,
  showLogoUrl,
  organiserLogoUrl,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.barContainer}>
        <Box className={classes.show}>
          <Avatar
            className={classes.showLogo}
            variant="square"
            src={showLogoUrl}
          >
            {title?.charAt(0)}
          </Avatar>
          <Typography variant="h3" component="h2" className={classes.text}>
            {title}
          </Typography>
        </Box>
        <Box className={classes.avatar}>
          <Typography variant="h3" component="h2" className={classes.text}>
            Organiser
          </Typography>
          <Avatar
            alt="Organiser"
            className={classes.organiserLogo}
            variant="square"
            src={organiserLogoUrl}
          >
            O
          </Avatar>
        </Box>
      </Box>
    </Box>
  );
};
export default TopBar;
